import React, { FC } from 'react';
import { createGTMQueryString } from 'utils/common/http';

export interface GoogleTagManagerProps {
  id: string;
  gtm_auth?: string;
  gtm_preview?: string;
  gtm_cookies_win?: string;
}

const GoogleTagManagerForBody: FC<GoogleTagManagerProps> = (props) => {
  const queryString = createGTMQueryString(props);
  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
          <iframe
            src="https://www.googletagmanager.com/ns.html?${queryString}"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>
        `,
      }}
    />
  );
};

export default GoogleTagManagerForBody;
